import {
  BRAND,
  PRIMARY,
  INTERACTION,
  MUTED,
  SOFT_BORDER,
  TEXT
} from "../shared/styles";

export default function HeroSection({
  companyName,
  betriebstyp,
  fte,
  standort,
  generatedAt,
  onAddDataClick,
  onSettingsClick,
  onExportClick,
  accountEmail,
  isMobile,
  highlightAddData
}) {
  const details = [
    `Anzahl Mitarbeitende: ${fte != null ? fte : "Noch nicht verfügbar"}`,
    `Betriebstyp: ${betriebstyp || "Noch nicht verfügbar"}`,
    standort
  ].filter(Boolean);
  const accountInitials = (accountEmail || "Konto")
    .split("@")[0]
    .split(/[.\s_-]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join("") || "GO";
  const showAccountText = !isMobile;

  return (
    <header
      style={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        justifyContent: "space-between",
        alignItems: isMobile ? "stretch" : "center",
        gap: "0.85rem",
        paddingBottom: "0.9rem",
        borderBottom: `1px solid ${SOFT_BORDER}`
      }}
    >
      <div style={{ minWidth: 0 }}>
        <div
          style={{
            color: BRAND,
            fontSize: "0.74rem",
            fontWeight: 700,
            textTransform: "uppercase"
          }}
        >
          GreenOne Dashboard
        </div>
        <div style={{ display: "flex", alignItems: "baseline", gap: "0.6rem", flexWrap: "wrap" }}>
          <h1 className="h1" style={{ fontSize: "clamp(1.3rem, 3vw, 1.9rem)", lineHeight: 1.2, color: TEXT, wordBreak: "break-word", margin: 0 }}>
            {companyName || "Betriebsübersicht"}
          </h1>
          {details.length > 0 && <span style={{ fontSize: "0.82rem", color: MUTED }}>{details.join(" · ")}</span>}
        </div>
        {generatedAt && (
          <div style={{ marginTop: "0.15rem", fontSize: "0.76rem", color: MUTED }}>
            Aktualisiert {generatedAt.toLocaleString("de-CH", { dateStyle: "short", timeStyle: "short" })}
          </div>
        )}
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: "0.65rem", flexWrap: "wrap", justifyContent: isMobile ? "flex-start" : "flex-end" }}>
        <span
          className={highlightAddData ? "goa-highlight-add-data" : undefined}
          style={highlightAddData ? { position: "relative", zIndex: 9500 } : undefined}
        >
          <sdx-button theme="secondary" label="Daten hinzufügen" onClick={onAddDataClick}></sdx-button>
        </span>
        <sdx-button theme="secondary" label="Daten exportieren" onClick={onExportClick}></sdx-button>
        <button
          type="button"
          onClick={onSettingsClick}
          style={{
            border: `1px solid ${INTERACTION}`,
            background: "#fff",
            borderRadius: "999px",
            padding: showAccountText
              ? "0.35rem 0.65rem 0.35rem 0.35rem"
              : "0.3rem",
            display: "flex",
            alignItems: "center",
            gap: showAccountText ? "0.65rem" : 0,
            cursor: "pointer",
            whiteSpace: "nowrap",
            boxShadow: "0 10px 30px rgba(15, 23, 42, 0.04)"
          }}
        >
          <span
            style={{
              width: 36,
              height: 36,
              borderRadius: "999px",
              display: "grid",
              placeItems: "center",
              background: `linear-gradient(135deg, ${BRAND}, ${PRIMARY})`,
              color: "#fff",
              fontWeight: 700,
              fontSize: "0.86rem",
              flexShrink: 0
            }}
          >
            {accountInitials}
          </span>
          {showAccountText && (
            <span style={{ textAlign: "left", minWidth: 0 }}>
              <span
                style={{
                  display: "block",
                  fontSize: "0.88rem",
                  fontWeight: 700,
                  color: TEXT
                }}
              >
                Konto
              </span>
              <span style={{ display: "block", fontSize: "0.76rem", color: MUTED, maxWidth: 220, overflow: "hidden", textOverflow: "ellipsis" }}>
                {accountEmail || "Einstellungen"}
              </span>
            </span>
          )}
        </button>
      </div>
    </header>
  );
}
